import { render } from "./AdsList.vue?vue&type=template&id=7ec81cf2&ts=true"
import script from "./AdsList.vue?vue&type=script&lang=ts"
export * from "./AdsList.vue?vue&type=script&lang=ts"

import "./AdsList.vue?vue&type=style&index=0&id=7ec81cf2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__